import Star from '@/shared/assets/icons/icon-star.svg';
import {
  RateContainer,
  RadioStar,
  RadioStarLabel,
} from './StarsRating.styled';

const MAX_RATE = 5;
const STARS = Array.from({ length: MAX_RATE }, (v, k) => MAX_RATE - k);

const StarsRating = ({ label, name, value, onClick, disabled = false }) => {
  return (
    <RateContainer>
      {STARS.map((rate) => (
        <RadioStarLabel
          key={`${label} ${rate}`}
          htmlFor={`${label} ${rate}`}
          $shouldFill={rate <= value}
          $disabled={disabled}
        >
          <RadioStar
            id={`${label} ${rate}`}
            name={name}
            value={rate}
            title={`${rate} star`}
            onClick={onClick}
            disabled={disabled}
          />
          <Star />
        </RadioStarLabel>
      ))}
    </RateContainer>
  );
};

export default StarsRating;
